import { Form, FormProps, Input, Select } from 'antd'
import { BaseKey } from '@refinedev/core'
import { SelectWithDefault } from 'components/input/SelectWithDefault'
import { ORG_TEAM_URL } from 'urls'

export const TeamForm: React.FC<{
  formProps: FormProps
  id?: BaseKey
  queryResult?: any
}> = ({ formProps, id }) => {
  return (
    <Form {...formProps} layout="vertical">
      <Form.Item name="name" label="Team Name" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="parent" label="Parent Team">
        <SelectWithDefault
          useSelectProps={{ resource: ORG_TEAM_URL, optionLabel: 'name' }}
        />
      </Form.Item>
    </Form>
  )
}
